import React from 'react';
import { useFormContext } from '../context/FormContext';
import {
    Container,
    Paper,
    Typography
} from '@mui/material';
import GoalSection from './GoalSection';
import NeedsSection from './NeedsSection';
import ValuesSection from './ValuesSection';
import ResourcesSection from './ResourcesSection';
import SupportingThoughtsSection from './SupportingThoughtsSection';
import EcologySection from './EcologySection';
import ActionPlanSection from './ActionPlanSection';
import PDFGenerator from './PDFGenerator';

const Chatbot = () => {
    const { formData, updateFormData, currentSection, setCurrentSection } = useFormContext();

    const sections = [
        {
            title: "Cel",
            component: GoalSection
        },
        {
            title: "Potrzeby",
            component: NeedsSection
        },
        {
            title: "Wartości",
            component: ValuesSection
        },
        {
            title: "Zasoby",
            component: ResourcesSection
        },
        {
            title: "Wspierające myśli",
            component: SupportingThoughtsSection
        },
        {
            title: "Ekologia",
            component: EcologySection
        },
        {
            title: "Plan działania",
            component: ActionPlanSection
        }
    ];

    const handleSectionComplete = (data) => {
        updateFormData(data);
        if (currentSection === sections.length - 1) {
            setCurrentSection(sections.length); // Move to PDF view
        } else {
            setCurrentSection(prev => prev + 1);
        }
    };

    const CurrentSectionComponent = sections[currentSection]?.component;

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            {currentSection < sections.length ? (
                <Paper elevation={3} sx={{ p: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center">
                        Therapp
                    </Typography>
                    {CurrentSectionComponent && (
                        <CurrentSectionComponent
                            onNext={handleSectionComplete}
                            formData={formData}
                        />
                    )}
                </Paper>
            ) : (
                <PDFGenerator formData={formData} />
            )}
        </Container>
    );
};

export default Chatbot; 